import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import useCurrencyCodeConfiguration from '../../../../hooks/configurations/useCurrencyCodeConfiguration';
import { applyRoundAndFormat } from '../../../../utils';
import { Item } from '../../../../app/services/api/orderManagementClient';

const ProductPricing = (props: {
  productDetails: Item | undefined,
}) => {
  const { t } = useTranslation('productDetails');
  const theme = useTheme();
  const { currencyCode, getCurrencyCodeConfiguration } = useCurrencyCodeConfiguration();

  useEffect(() => {
    getCurrencyCodeConfiguration();
  }, []);

  return (
    <TableContainer sx={{ borderRadius: '12px' }}
      component='div'>
      <Table size="small">
        <TableHead sx={{ backgroundColor: theme.palette.custom.gray[200] }}>
          <TableRow>
            <TableCell width={'50%'}>
              {t('type')}
            </TableCell>
            <TableCell>
              {t('value')}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>
              <Typography variant='textXS'>
                {t('pricingTab.unitPrice')}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant='textXS'>
                {applyRoundAndFormat(props.productDetails?.unitPrice ?? 0, currencyCode)}
                {props.productDetails?.gbpPrice !== undefined &&
                 props.productDetails?.price !== props.productDetails?.gbpPrice && (
                  <span
                    style={{
                      color: theme.palette.text.disabled,
                      fontStyle: 'italic',
                      marginLeft: 6,
                      fontSize: '0.95em',
                    }}
                  >
                  ({applyRoundAndFormat(props.productDetails.gbpPrice / props.productDetails.caseSize, 'GBP')})
                  </span>
                )}     
              </Typography>
            </TableCell>
          </TableRow>
                  
          <TableRow>
            <TableCell>
              <Typography variant='textXS'>
                {t('pricingTab.casePrice')}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant='textXS'>
                {applyRoundAndFormat(props.productDetails?.price ?? 0, currencyCode)}
                {props.productDetails?.gbpPrice !== undefined &&
                 props.productDetails?.price !== props.productDetails?.gbpPrice && (
                  <span
                    style={{
                      color: theme.palette.text.disabled,
                      fontStyle: 'italic',
                      marginLeft: 6,
                      fontSize: '0.95em',
                    }}
                  >
                  ({applyRoundAndFormat(props.productDetails.gbpPrice, 'GBP')})
                  </span>
                )}              
              </Typography>
            </TableCell>
          </TableRow>
          {props.productDetails?.rrp != null &&       
          <TableRow>
            <TableCell>
              <Typography variant='textXS'>
                {t('pricingTab.recommendedRetailPrice')}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant='textXS'>
                {applyRoundAndFormat(
                  props.productDetails.rrp > 0
                    ? props.productDetails.rrp
                    : 0.0,
                  currencyCode,
                )}
              </Typography>
            </TableCell>
          </TableRow>
          }
          {props.productDetails?.por != null &&
          <TableRow>
            <TableCell>
              <Typography variant='textXS'>
                {t('pricingTab.por')}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant='textXS'>
                {props.productDetails.por > 0
                  ? props.productDetails.por.toFixed(2)
                  : '0.00'
                }%            
              </Typography>
            </TableCell>
          </TableRow>
          }
                  
          <TableRow>
            <TableCell>
              <Typography variant='textXS'>
                {t('pricingTab.minUnitPrice')}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant='textXS'>
                {applyRoundAndFormat(
                  props.productDetails?.minimumUnitPrice && props.productDetails.minimumUnitPrice > 0
                    ? props.productDetails.minimumUnitPrice
                    : 0.0,
                  currencyCode,
                )}
              </Typography>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ProductPricing;